import { useState } from "react";
import { ChevronDown, ChevronUp, LogIn, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export function fmtWhen(iso) {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" }); }
  catch { return iso; }
}

function agentLabel(ua = "") {
  const os = /iPhone|iPad/.test(ua) ? "iOS" : /Android/.test(ua) ? "Android" : /Mac/.test(ua) ? "Mac" : /Windows/.test(ua) ? "Windows" : "";
  const br = /Edg\//.test(ua) ? "Edge" : /Chrome\//.test(ua) ? "Chrome" : /Safari\//.test(ua) ? "Safari" : /Firefox\//.test(ua) ? "Firefox" : "";
  return [br, os].filter(Boolean).join(" · ") || "Unknown device";
}

export function LoginInfo({ email, last, count, testId = "login-info" }) {
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState(null);

  const toggle = async () => {
    const next = !open; setOpen(next);
    if (next && rows === null) {
      try { const { data } = await api.get(`/admin/logins?email=${encodeURIComponent(email)}&limit=25`); setRows(data); }
      catch { setRows([]); }
    }
  };

  if (!last) return <span className="text-xs text-sbg-burgundy/50" data-testid={`${testId}-never`}>Never signed in</span>;
  return (
    <div data-testid={testId}>
      <button type="button" onClick={toggle} data-testid={`${testId}-toggle`} className="inline-flex items-center gap-1.5 text-xs font-semibold text-sbg-burgundy hover:text-sbg-fuchsia">
        <LogIn className="h-3.5 w-3.5 text-sbg-raspberry" /> {fmtWhen(last.at)}
        {count ? <span className="text-sbg-burgundy/50">({count})</span> : null}
        {open ? <ChevronUp className="h-3.5 w-3.5" /> : <ChevronDown className="h-3.5 w-3.5" />}
      </button>
      {open && (
        <div className="mt-2 max-h-56 overflow-auto rounded-xl bg-sbg-blush/30 p-3 text-xs text-sbg-burgundy/80" data-testid={`${testId}-list`}>
          {rows === null ? <Loader2 className="h-4 w-4 animate-spin" /> : rows.length === 0 ? "No sign-ins recorded." : (
            <ul className="space-y-1.5">
              {rows.map((r) => (
                <li key={r.id} className="flex flex-wrap justify-between gap-2">
                  <span className="font-semibold text-sbg-burgundy">{fmtWhen(r.at)}</span>
                  <span>{agentLabel(r.user_agent)}{r.ip ? ` · ${r.ip}` : ""}{r.method === "page-verify" ? " · page verification" : ""}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}
